import {Nullable} from 'Common/types';

export interface IFormValues {
  subscriptionId: Nullable<number>;
}

export const initialValue: IFormValues = {
  subscriptionId: null,
};
